'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import { modalService } from '@/services/modal.service';

const LoginModal = dynamic(
	() => import('./login-modal').then(m => m.LoginModal),
	{ ssr: false }
);

export const LoginModalLoader = () => {
	const [shouldRender, setShouldRender] = useState(false);
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const subscription = modalService.onOpenLoginModel.subscribe(isOpen => {
			if (isOpen) {
				setShouldRender(true);
			};
			setIsOpen(isOpen);
		});

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	const closeModal = () => setIsOpen(false);

	if (!shouldRender) {
		return null;
	}

	return (
		<LoginModal 
			isOpen={isOpen} 
			onClose={closeModal} 
		/>
	);
	return null;
};